import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";


export const getImages = createAsyncThunk(
	"images/",
	async ({ get, generator_id, variant_index }) => {
	  const response = await get(`/webapp/characters/${generator_id}/images/${variant_index}/`);
	  return response;
	}
);

export const getLoraImage = createAsyncThunk(
  "image/",
  async ({ id, get }) => {
    const response = await get(`/webapp/images/${id}/`);
    return response;
  }
);

let intervals = {};

export const startLoraImagePolling =
({ id, get, generator_id, variant_index }) =>
(dispatch) => {

  if (intervals[id]) {
    return;
  }

  const interval = setInterval(async () => {
    try {
      const lora = await dispatch(getLoraImage({ id, get })).unwrap();
      // console.log(lora);
      if (lora && lora.finished) {
        dispatch(getImages({ get, generator_id, variant_index }));
        clearInterval(interval);
        delete intervals[id];
      }
    } catch (error) {
      console.error("Error fetching lora image:", error);
      clearInterval(interval);
      delete intervals[id];
    }
  }, 5000);

  intervals[id] = interval;
  console.log(`Polling started for lora image ID: ${id}`);

  dispatch(getImages({ get, generator_id, variant_index }));
};


const imagesSlice = createSlice({
  name: "images",
  initialState: {
	items: [],
    status: "idle",
    error: null,
  },
  reducers: {
    deleteImage: (state, action) => {
      const id = action.payload;
      state.items = state.items.filter((image) => image.id !== id);
      // delete polling interval if the image is deleted
      console.log(intervals[id])
      if(intervals[id]){
        console.log("CLEARING INTERVAL FOR DELETED IMAGE");
        clearInterval(intervals[id]);
        delete intervals[id];
      }
    },
    updateImage: (state, action) => {
      const { id, data } = action.payload;
      const index = state.items.findIndex((image) => image.id === id);

      if (index !== -1) {
        state.items[index] = { ...state.items[index], ...data };
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getImages.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getImages.fulfilled, (state, action) => {
        state.status = "succeeded";

        let newItems = [];
        if (Array.isArray(action.payload)) {
          newItems = action.payload.filter(
            (item) =>
              !state.items.some(
                (existingCharacter) => item.id === existingCharacter.id
              )
          );

          action.payload.forEach((updatedItem) => {
            const index = state.items.findIndex(
              (item) => item.id === updatedItem.id
            );
            if (index !== -1) {
              state.items[index] = {
                ...state.items[index],
                ...updatedItem,
              };
            }
          });
		    }

        state.items = [...newItems, ...state.items];
      })
      .addCase(getImages.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export const { deleteImage } = imagesSlice.actions;
export default imagesSlice.reducer;
